import { useState } from 'react';
import { IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import styled from 'styled-components';
import { selectCars } from '../features/car/carSlice';
import { useSelector } from 'react-redux';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const cars = useSelector(selectCars);

  return (
    <Container>
      <a>
        <img src='/images/newlogo.svg' alt='' />
      </a>

      <Menu>
        {cars &&
          cars.map((car) => (
            <a href='#' key={car}>
              {car}
            </a>
          ))}
      </Menu>

      <RightMenu>
        <a href='#'>Shop</a>
        <a href='#'> Account</a>
        <CustomMenu onClick={() => setIsMenuOpen(true)}>
          <MenuIcon />
        </CustomMenu>
      </RightMenu>

      <BurgerNav show={isMenuOpen}>
        <CloseWrapper onClick={() => setIsMenuOpen(false)}>
          <IconButton>
            <CloseIcon />
          </IconButton>
        </CloseWrapper>

        {cars &&
          cars.map((car) => (
            <li key={car}>
              {' '}
              <a href='#' key={car}>
                {car}
              </a>
            </li>
          ))}
        <li>
          <a href='#'>Existing Inventory</a>
        </li>

        <li>
          <a href='#'>Used Inventory</a>
        </li>

        <li>
          <a href='#'>Trade-in</a>
        </li>

        <li>
          <a href='#'>CYBERTRUCK</a>
        </li>

        <li>
          <a href='#'>ROADSTER</a>
        </li>

        <li>
          <a href='#'>SEMI</a>
        </li>

        <li>
          <a href='#'>CHARGING</a>
        </li>

        <li>
          <a href='#'>POWERWALL</a>
        </li>

        <li>
          <a href='#'>COMMERCIAL SOLAR</a>
        </li>

        <li>
          <a href='#'>TEST DRIVE</a>
        </li>
      </BurgerNav>
    </Container>
  );
};

const Container = styled.header`
  min-height: 60px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
  z-index: 111;

  img {
    width: 120px;
    height: 40px;
    object-fit: contain;
  }
`;

const Menu = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: center;

  a {
    display: inline-block;
    font-weight: 600;
    text-transform: uppercase;
    padding: 0 0.75rem;
  }

  @media (max-width: 786px) {
    display: none;
  }
`;

const RightMenu = styled.div`
  display: flex;
  align-items: center;
  a {
    display: inline-block;
    font-weight: 600;
    margin-right: 0.75rem;
  }
`;

const CustomMenu = styled(IconButton)``;

const BurgerNav = styled.ul`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  width: 30%;
  z-index: 222;
  transition: all 0.3s ease-in-out;
  padding: 1rem;
  text-align: left;
  /* transform: translateX(100%);    */
  transform: ${(props) => (props.show ? 'translateX(0%)' : 'translateX(100%)')};

  li {
    list-style: none;
    padding: 0.75rem 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);

    a {
      font-weight: 400;
    }
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const CloseWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export default Header;
